import { FunctionComponent, useEffect, useState } from 'react';
import {
    FilledInput,
    FormControl,
    InputAdornment,
    InputLabel,
    OutlinedInputProps,
} from '@mui/material';
import { MultiLangString } from '@starjack/utils';
import { MultiLangAdornment } from './multiLangAdornment';

export const MultiLangInput: FunctionComponent<{
    sx?: OutlinedInputProps['sx'];
    label: string;
    value?: MultiLangString;
    onChange?: (langString: MultiLangString) => void;
    onBlur?: (langString: MultiLangString) => void;
    fullWidth?: boolean;
}> = ({ value = null, sx, label, onChange, onBlur, fullWidth }) => {
    const [internalValue, setInternalValue] = useState<MultiLangString>(
        value || { de: '', en: '' }
    );
    const [currentLang, setCurrentLang] = useState<'de' | 'en'>('de');

    useEffect(() => {
        if (value) {
            setInternalValue(value);
        }
    }, [value]);

    return (
        <FormControl sx={{ ...sx }} variant='filled' fullWidth={fullWidth}>
            <InputLabel htmlFor='outlined-adornment-password'>
                {label}
            </InputLabel>
            <FilledInput
                sx={{
                    pr: 0,
                }}
                type={'text'}
                value={internalValue[currentLang]}
                onChange={(e) => {
                    const { value } = e.target;

                    const nextValue = {
                        ...{ de: '', en: '' },
                        ...internalValue,
                        [currentLang]: value,
                    };

                    setInternalValue(nextValue);
                    if (onChange) onChange(nextValue);
                }}
                onBlur={() => {
                    if (onBlur) onBlur(internalValue);
                }}
                endAdornment={
                    <InputAdornment
                        sx={{
                            height: 'auto',
                            maxHeight: 'unset',
                        }}
                        position='end'
                    >
                        <MultiLangAdornment
                            currentLang={currentLang}
                            onChangeLang={(nextLang) =>
                                setCurrentLang(nextLang)
                            }
                        />
                    </InputAdornment>
                }
            />
        </FormControl>
    );
};
